// src/components/TareaCard.js

import React from 'react';
import Card from './Card';
import Button from './Button';
import { FaHome, FaSchool, FaSeedling, FaExclamationTriangle } from 'react-icons/fa';

// --- Componente para el icono de categoría ---
const CategoriaIcon = ({ categoria }) => {
  const styles = "w-6 h-6 text-principal";
  if (categoria === 'ESCUELA') return <FaSchool className={styles} />;
  if (categoria === 'HABITOS') return <FaSeedling className={styles} />;
  return <FaHome className={styles} />; // HOGAR por defecto
};

function TareaCard({ tarea, onCompletar }) {
  // Asignamos clases de color basadas en el nuevo campo 'status'
  const cardColorClass = 
    tarea.status === 'APROBADA' ? 'bg-green-100' :
    tarea.status === 'COMPLETADA' ? 'bg-yellow-100' :
    tarea.status === 'RECHAZADA' ? 'bg-red-100 border-2 border-red-300' : 
    'bg-white'; // Estado PENDIENTE

  return (
    <Card className={`transition-all duration-300 transform hover:scale-105 ${cardColorClass}`}>
      <div className='flex justify-between items-start'>
        <div className='flex items-center gap-3'>
          <CategoriaIcon categoria={tarea.categoria} />
          <h3 className="text-xl font-bold text-gray-800">{tarea.titulo}</h3>
        </div>
        <div className="font-bold text-acento text-lg bg-yellow-100 rounded-full px-4 py-1">{tarea.puntos} ✨</div>
      </div>
      <p className="text-gray-600 my-4">{tarea.descripcion}</p>

      {/* Mostramos el comentario del padre si la tarea fue rechazada */}
      {tarea.status === 'RECHAZADA' && tarea.comentario_padre && (
        <div className="mt-4 p-3 bg-red-200 text-red-800 rounded-lg text-sm">
          <p className="font-bold flex items-center gap-2"><FaExclamationTriangle /> ¡A revisar!</p>
          <p className="italic mt-1">"{tarea.comentario_padre}"</p>
        </div>
      )}
      
      <div className="flex justify-center items-center mt-4 pt-4 border-t-2 border-dashed">
        {/* Si la tarea está PENDIENTE o RECHAZADA, el niño puede (re)completarla */}
        {(tarea.status === 'PENDIENTE' || tarea.status === 'RECHAZADA') && (
          <Button onClick={() => onCompletar(tarea.id)} className="w-full shadow-md">
            {tarea.status === 'RECHAZADA' ? '¡Lo he corregido!' : '¡Lo Terminé!'}
          </Button>
        )}
        {/* Si está COMPLETADA, espera aprobación */}
        {tarea.status === 'COMPLETADA' && (
          <span className="text-sm text-yellow-600 font-semibold bg-yellow-200 px-4 py-2 rounded-full">
            ⏳ Esperando aprobación...
          </span>
        )}
        {/* Si está APROBADA, se muestra como un logro */}
        {tarea.status === 'APROBADA' && (
           <span className="text-sm text-green-700 font-bold bg-green-200 px-4 py-2 rounded-full">
            ¡Aprobada! 🎉
           </span>
        )}
      </div>
    </Card>
  );
}

export default TareaCard;